import {announceFromElement} from '@github-ui/aria-live'
import {observe} from '@github/selector-observer'

observe('.js-starred-repos-search-results', function (el) {
  announceFromElement(el as HTMLElement)
})
